export default __webpack_public_path__ + "static/media/product-1.91b7154d.jpg";